const msg_error = (msg) => {
    console.log(msg)
    for (let i = 0; i < english.length; i++) {
        if(english[i] === msg) return spanish[i];
    }
    return msg;
}



const english = [

//Tarjetas
    "The card number verification digit is invalid",
    "The expiration date has expired",
    "The CVV2 security code is required",
    "The card number is only valid in sandbox",
    "The card is not valid for points",
    "The CVV2 security code is invalid",
    "3D Secure authentication failed",
    "Card product type not supported",
    "The card was declined by the bank",
    "The card has expired",
    "The card doesn't have sufficient funds",
    "The card was reported as stolen",
    "Request not allowed",
    "The card was reported as lost",
    "The bank has restricted the card",
    "The bank has requested the card to be retained",
    "Bank authorization is required for this charge",
    "Merchant not authorized to use payment plan",
    "Invalid promotion for such card type",
    "Transaction amount is less than minimum for promotion",
    "Promotion not allowed",
    "cvv2 length must be 4 digits",
    "cvv2 length must be 3 digits",
    "Fraud risk detected by anti-fraud system",
    "Found in blacklist",

//Generales
    "Internal server error, contact support",
    "Bad Request",
    "The api key or merchant id are invalid",
    "Parameters look valid but request failed",
    "The resource is unavailable at this moment. Please try again later",
    "The requested resource doesn't exist",
    "The order_id has already been processed",
    "Operation rejected by processor",
    "The account is inactive",
    "The request is too large",
    "Method not allowed for public API key, use private key instead",
    "The resource was previously deleted",
    "The transaction amount exceeds your allowed transaction limit",
    "The operation is not allowed on the resource",
    "Your account is inactive, please contact to soporte@openpay.mx for more information",
    "Could not get any response from gateway. Please try again later",
    "The merchant email has been already processed",
    "The payment gateway is not available at the moment, please try again later",
    "The number of retries of charge is greater than allowed",
    "The number of decimal digits is not valid for this currency",

//Practicaja
    "Your payment cannot be assigned",
    "This payment has already been assigned",
    "payment not found"
]

const spanish = [

//Tarjetas
    "El número de tarjeta es invalido.",
    "La fecha de expiración de la tarjeta es anterior a la fecha actual.",
    "El código de seguridad de la tarjeta (CVV2) no fue proporcionado.",
    "El número de tarjeta es de prueba, solamente puede usarse en Sandbox.",
    "La tarjeta no es valida para pago con puntos.",
    "El código de seguridad de la tarjeta (CVV2) es inválido.",
    "Autenticación 3D Secure fallida.",
    "Tipo de tarjeta no soportada.",
    "La tarjeta fue declinada por el banco.",
    "La tarjeta ha expirado.",
    "La tarjeta fue declinada.",
    "La tarjeta fue declinada.",
    "La operación no esta permitida para este cliente o esta transacción.",
    "La tarjeta fue reportada como perdida.",
    "El banco ha restringido la tarjeta.",
    "El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.",
    "Se requiere solicitar al banco autorización para realizar este pago.",
    "Comercio no autorizado para procesar pago a meses sin intereses.",
    "Promoción no valida para este tipo de tarjetas.",
    "El monto de la transacción es menor al mínimo permitido para la promoción.",
    "Promoción no permitida.",
    "La longitud de cvv2 debe ser de 4 dígitos",
    "La longitud de cvv2 debe ser de 3 dígitos",
    "La tarjeta fue declinada.",
    "La tarjeta fue declinada.",

//Generales
    "Ocurrió un error interno en el servidor de Openpay",
    "El formato de la petición no es JSON, los campos no tienen el formato correcto, o la petición no tiene campos que son requeridos.",
    "La llamada no esta autenticada o la autenticación es incorrecta.",
    "La operación no se pudo completar por que el valor de uno o más de los parámetros no es correcto.",
    "Un servicio necesario para el procesamiento de la transacción no se encuentra disponible.",
    "Uno de los recursos requeridos no existe.",
    "Ya existe una transacción con el mismo ID de orden.",
    "La transferencia de fondos entre una cuenta de banco o tarjeta y la cuenta de Openpay no fue aceptada.",
    "Una de las cuentas requeridas en la petición se encuentra desactivada.",
    "El cuerpo de la petición es demasiado grande.",
    "Se esta utilizando la llave pública para hacer una llamada que requiere la llave privada, o bien, se esta usando la llave privada desde JavaScript.",
    "Se solicita un recurso que esta marcado como eliminado.",
    "El monto transacción esta fuera de los limites permitidos.",
    "La operación no esta permitida para el recurso.",
    "La cuenta esta inactiva.",
    "No se ha obtenido respuesta de la solicitud realizada al servicio.",
    "El mail del comercio ya ha sido procesada.",
    "El gateway no se encuentra disponible en ese momento.",
    "El número de intentos de cargo es mayor al permitido.",
    "El número de dígitos decimales es inválido para esta moneda",

//Practicaja
    "Su pago no se puede asignar",
    "Este pago ya ha sido asignado",
    "pago no encontrado"
]

export {
    msg_error
}